
import Carousels from './Componentes/Carousels';
import './assets/css/bases.css'
import { BrowserRouter } from 'react-router-dom';
import Menu from './Componentes/Menu';
import Footer from './Componentes/Footer';
import Nosotros from './Componentes/Nosotros';
import Public from './Routes/Public';
import BotonWhatsapp from './Componentes/BotonWhatsapp';

const styles = {
  container:{
    heigth:"100px",

  }
}

function App() {
  return (
    <>
      <BrowserRouter>  
        <Menu/>
        <BotonWhatsapp/>
        <Public/>
        <Footer/>
      </BrowserRouter>
        
    </>
  );
}

export default App;
